import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocalizationService } from "../apis/localization/useLocalizationService";
import {
  TLocalization,
  TUpdateLocalizationRequest,
} from "../apis/localization/localization.interfaces";
import { useInstituteContext } from "../context/institute.context";

export const useLocalizationHook = () => {
  const { getLocalization } = useLocalizationService();
  const { selectedInstitute } = useInstituteContext();

  return useQuery<TLocalization>({
    queryKey: ["localization", selectedInstitute?.id],
    queryFn: () => getLocalization(selectedInstitute?.id),
    enabled: !!selectedInstitute?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useUpdateLocalizationHook = () => {
  const { updateLocalization } = useLocalizationService();
  const queryClient = useQueryClient();
  const { selectedInstitute } = useInstituteContext();

  return useMutation<
    TLocalization,
    Error,
    { id: string; request: TUpdateLocalizationRequest }
  >({
    mutationFn: ({ id, request }) => updateLocalization(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["localization", selectedInstitute?.id],
      });
    },
  });
};
